<template>
<div class="background-01">
  <v-layout row wrap>
    <router-link aria-label="Página anterior" class="rout-bot bot-left hvr-grow" to="/"></router-link>
    <ui-title-red textTitle="Introducción"></ui-title-red>
    <v-flex xs12 sm12 text-xs-center>
      <ui-simple-lsc @hideVideo="hideVideo" :vidTittle="'Introducción'" videoEmbed="info01comoadministrar.mp4"></ui-simple-lsc>
    </v-flex>
    <v-flex v-if="videoAcc" xs12 sm12 text-xs-center class="animated fadeIn dura_1">
      <br>
      <video-app class="adorn-bottom" :videoSize="700" vidTittle="video Presentacion" youtubeEmbed="3jn8-qHEI5w?autoplay=1&rel=0"></video-app>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
export default {
  props: {
    modName: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      videoAcc: true
    };
  },
  methods: {
    hideVideo(video) {
      this.videoAcc = !video
    }
  },
  mounted() {
    this.$store.commit("nextShow", true);
  }
};
</script>



// WEBPACK FOOTER //
// davivienda-01.vue?03c35557